var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"autoflex-oc-app"}},[_c('router-view',{attrs:{"settings":_vm.settings}}),_c('div',{staticClass:"version"},[_vm._v("Powered by Autoflex | "+_vm._s(this.$store.getters.appVersion))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }